import { useNavigate } from "@tanstack/react-router";

import {
  Button,
  EmptyState,
  Page,
  Panel,
  Stack,
  StatusBadge,
} from "@/components/ui";

import { Facts } from "../components/Text";

import { QueryPanel } from "./components/QueryPanel";
import { useEntitlement } from "./lib/queries";
import { tallySources } from "./lib/present";

/** The entitlement is the only billing-adjacent read that answers. Nothing behind it is built. */
export function ConsoleBilling() {
  const navigate = useNavigate();
  const entitlement = useEntitlement();

  const sources = entitlement.data?.sources ?? [];
  const comped = sources.length > 0 && sources.every((one) => one.kind === "grant");

  return (
    <Page
      title="Billing"
      actions={
          <Button
            size="sm"
            variant="secondary"
            onClick={() => {
              void navigate({ to: "/console/plan" });
            }}
          >
            Plan
          </Button>
      }
    >

      <QueryPanel title="Access" rows={3} query={entitlement}>
        {(held) => (
          <Stack gap={4}>
            <Facts
              items={[
                { label: "Billed plan", value: held.plan_id ?? "none", mono: true },
                {
                  label: "Sources",
                  value:
                    sources.length === 0 ? (
                      "none"
                    ) : (
                      <div className="cx-chips">
                        {tallySources(sources).map((source) => (
                          <StatusBadge
                            key={`${source.kind}:${source.plan_id}`}
                            tone={source.kind === "grant" ? "info" : "success"}
                          >
                            {source.count === 1
                              ? `${source.kind} ${source.plan_id}`
                              : `${source.kind} ${source.plan_id} x${String(source.count)}`}
                          </StatusBadge>
                        ))}
                      </div>
                    ),
                },
                { label: "Comped", value: comped ? "yes" : "no" },
              ]}
            />
          </Stack>
        )}
      </QueryPanel>

      <Panel title="Subscription">
        <EmptyState bare headline="Not available" />
      </Panel>

      <Panel title="Invoices">
        <EmptyState bare headline="Not available" />
      </Panel>

      {comped ? null : (
        <Panel title="Payment method">
          <Stack gap={3}>
            <EmptyState bare headline="Not available" />
            <div className="cx-verbs">
              <Button size="sm" variant="secondary" disabled>
                Change plan
              </Button>
              <Button size="sm" variant="ghost" disabled>
                Update payment method
              </Button>
            </div>
          </Stack>
        </Panel>
      )}
    </Page>
  );
}
